'use strict';

var sanitizeMongoKeys = require('../utils/sanitizeMongoKeys');

module.exports = function ($state, departments, Department, Integration, dialog, graphs, $translate, Authentication, $uibModal, toast, $rootScope, $scope) {
    var _this = this;
    this.loadingGraphs = false;

    this.department = departments.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];

    // console.log('this.department', this.department)
    // console.log('departments', departments)

    this.currentUserIsViewer=Authentication.isAuthorized("viewer");
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");

    this.baseUrl = require('../server').server;
    this.department.graphs = graphs;

    // Recargar lista al volver desde el graph builder. Esto es necesario porque el builder no actualiza el listado de tableros al guardar uno nuevo.
    let offStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
        if (toState.name === 'dashboard.departments.department.graphs' &&
            fromState && fromState.name === 'dashboard.departments.department.graphs.gbuilder') {
            _this.loadingGraphs = true;
            Department.graphs({ id: toParams.departmentId })
                .$promise
                .then(function (refreshedGraphs) {
                    _this.department.graphs = refreshedGraphs;
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error($translate.instant("Error al cargar los tableros"));
                })
                .finally(function () {
                    _this.loadingGraphs = false;
                });
        }
    });
    $scope.$on('$destroy', function () {
        offStateChangeSuccess();
    });

    this.createGraph = function() {
        $state.go('dashboard.departments.department.graphs.gbuilder', {
            graphId: 'new'
        });
    };

    this.importGraph = function (graph) {
        toast.loading($translate.instant("DASHBOARD.LOADING"));
        $uibModal
        .open({
            animation: true,
            templateUrl: "dashboard-graphs/importGraphDialog.html",
            controller: [
                "$scope",
                "$uibModalInstance",
                "Authentication",
                function (
                    $scope,
                    $uibModalInstance,
                    Authentication,
                ) {
                    var _this = this;
                    $scope.fileContent = undefined;
                    _this.fileContent = undefined;
                    _this.graphName = "";

                    _this.flattenedForms = [];
                    _this.integrations = [];
                    _this.fileIncludeDS = false;

                    // console.log('llamado 8 Authentication.loadDepartments()')
                    Authentication.loadDepartments().then(function(departments) {
                        // console.log('departments', departments);
                        departments.forEach(function (department) {
                            department.forms.forEach(function (form) {
                                if (!form.id == '') { // if form.id == '' is not included
                                    _this.flattenedForms.push({
                                        departmentName: department.name,
                                        formName: form.name,
                                        formId: form.id,
                                    });
                                }
                            });
    
                        });
                        // console.log('_this.flattenedForms', _this.flattenedForms);
                    });                    
                    
                    Integration.find()
                        .$promise
                        .then(function (integrations) {
                            _this.integrations = integrations;
                        }
                    );

                    _this.clearFileInput = function (error) {
                        // If it is the first time the file is loaded
                        if ($scope.fileContent === undefined) {
                            _this.openNewFile();
                        // If a file was uploaded, the uploaded data will be lost.
                        } else {
                            if (error) {
                                $scope.fileContent = undefined;
                                _this.fileContent = undefined;
                                _this.graphName = "";

                                dialog.confirm({
                                    title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
                                    body: $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.FILE_WITHOUT_GRAPH"),
                                    accept: $translate.instant("DASHBOARD.ACCEPT"),
                                    cancel: $translate.instant("DASHBOARD.CANCEL"),
                                    size: "md",
                                })
                                .then(function () {
                                    _this.openNewFile();
                                });
                            } else {
                                dialog.confirm({
                                    title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
                                    body: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.DIALOG_CONFIRM.BODY"),
                                    accept: $translate.instant("DASHBOARD.ACCEPT"),
                                    cancel: $translate.instant("DASHBOARD.CANCEL"),
                                    size: "md",
                                })
                                .then(function () {
                                    $scope.fileContent = undefined;
                                    _this.fileContent = undefined;
                                    _this.graphName = "";
                                    _this.openNewFile();
                                });
                            }
                        }
                    };
                
                    _this.openNewFile = function () {
                        // Create file input, open the file selection window, asign value to fileContent.
                        var input = document.createElement('input');
                        input.type = 'file';
                        input.accept = '.json'; // only .json files
                        input.style.display = 'none';
                        document.body.appendChild(input);
                
                        input.addEventListener('change', function () {
                            var file = input.files[0];
                            var reader = new FileReader();
                            reader.onload = function (event) {
                                try {
                                    // Parse JSON content
                                    var fileContent = JSON.parse(event.target.result);
                                    $scope.$apply(function () {
                                        $scope.fileContent = fileContent;
                                    });
                                    _this.fileContent = fileContent;
                                    this.fileContent = fileContent;

                                    if (!fileContent?.graph) {
                                        _this.clearFileInput(true);
                                        throw new Error("FILE_WITHOUT_GRAPH");
                                    } else {
                                        _this.analizeFile(this.fileContent);
    
                                        // console.log('this.fileContent', this.fileContent)
                                        _this.graphName = fileContent?.graph?.name;
                                        // console.log('$scope.fileContent', $scope.fileContent);
                                        // console.log('_this.fileContent', _this.fileContent);
                                    }
                                } catch (error) {
                                    console.error('Error parsing JSON:', error);
                                    $scope.$apply(function () {
                                        if (error.message === "FILE_WITHOUT_GRAPH") {
                                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.FILE_WITHOUT_GRAPH"));
                                        } else {
                                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.FILE_VALID"));
                                        }
                                    });
                                }
                            };
                            reader.readAsText(file);
                            document.body.removeChild(input);
                        });
                    
                        input.click();
                    }

                    this.analizeFile = function (fileContent) {
                        _this.fileIncludeDS = false; // Reset the flag before analysis
                    
                        // Map for quick search of forms and integrations
                        const formMap = new Map(_this.flattenedForms.map(form => [form.formId, form.formName]));
                        const integrationMap = new Map(_this.integrations.map(integration => [integration.id, integration.name]));
                    
                        // console.log('fileContent analizeFile', fileContent);
                        for (var i = 0; i < fileContent.graph.pages.length; i++) {
                            var page = fileContent.graph.pages[i];
                            // console.log('page', i, page);
                            for (var j = 0; j < page.fields.length; j++) {
                                var field = page.fields[j];
                                // console.log('field.type', field.type)
                                if (field.type === 'datasource' && field.templateData && field.templateData.datasource) {
                                    const datasource = field.templateData.datasource;
                    
                                    // console.log('datasource.type', datasource.type)
                                    if (datasource.type === 'query' || datasource.type === 'action') {
                                        datasource.formNameOld = datasource.formName;
                                        delete datasource.formName;

                                        if (!formMap.has(datasource.formId)) {
                                            _this.fileIncludeDS = true;
                                            // Clear formId if it does not match
                                            datasource.formId = "";
                                            if (datasource.type === 'action') {
                                                datasource.actionId = undefined;
                                                datasource.actionIndex = undefined;
                                                delete datasource.actionName;
                                            }
                                        }
                                    } else if (datasource.type === 'integration') {
                                        datasource.integrationNameOld = datasource.integrationName;
                                        delete datasource.integrationName;

                                        if (!integrationMap.has(datasource.integrationId)) {
                                            _this.fileIncludeDS = true;
                                            // Clear integrationId if it does not match
                                            datasource.integrationId = "";
                                        }
                                    }
                    
                                    // console.log('datasource.formId || datasource.integrationId', datasource.formId, datasource.integrationId)
                                    // Check if there is any valid datasource
                                    if (datasource.formId || datasource.integrationId || (datasource.type === 'action' && (datasource.actionId || (datasource.actionIndex !== undefined && datasource.actionIndex !== null && datasource.actionIndex !== '')))) {
                                        _this.fileIncludeDS = true;
                                    }
                                }
                            }
                            $scope.$apply();
                        }
                    };

                    this.close = () => {
                        if (!_this.fileContent?.graph) {
                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.FILE_WITHOUT_GRAPH"));
                            return;
                        }

                        const pages = _this.fileContent.graph.pages;
                        if (!Array.isArray(pages) || !pages.length) {
                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.FILE_WITHOUT_GRAPH"));
                            return;
                        }

                        for (let page of pages) {
                            if (!page.fields) {
                                continue;
                            }
                            for (let field of page.fields) {
                                if (field.type === 'datasource' && field.templateData && field.templateData.datasource) {
                                    const datasource = field.templateData.datasource;
                                    if ((datasource.type === 'query' && !datasource.formId) ||
                                        (datasource.type === 'action' && (!datasource.formId || (!datasource.actionId && (datasource.actionIndex === undefined || datasource.actionIndex === null || datasource.actionIndex === '')))) ||
                                        (datasource.type === 'integration' && !datasource.integrationId)) {
                                        toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.MISSING_DS"));
                                        return;
                                    }
                                }
                            }
                        }

                        const graph = sanitizeMongoKeys(JSON.parse(JSON.stringify(_this.fileContent.graph)));
                        graph.name = _this.graphName;

                        if (!graph?.name?.trim()) {
                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.NO_NAME"));
                            return;
                        }

                        for (var i = 0; i < graph.pages.length; i++) {
                            if (!graph.pages[i].fields.length) {
                                toast.error(
                                    $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.PAGE_WITHOUT_ELEMENTS", { page: i + 1 })
                                );
                                return;
                            }
                        }

                        delete graph.temporalRepository;
                        delete graph.id;
                        _this.loading = true;

                        Department.graphs.create({
                            id: $state.params.departmentId
                        }, graph)
                            .$promise
                            .then(function (instance) {
                                if (!instance || !instance.id) {
                                    _this.loading = false;
                                    toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.CREATE_NO_ID"));
                                    return;
                                }

                                toast.success(
                                    $translate.instant("DASHBOARD.DASH_BUILDER.SAVE_OK_TOAST")
                                );
                                _this.loading = false;
                                $uibModalInstance.close({});

                                return $state
                                    .go("dashboard.departments.department.graphs", {}, { reload: true })
                                    .then(function () {
                                        return $state.go(
                                            "dashboard.departments.department.graphs.gbuilder",
                                            {
                                                graphId: instance.id,
                                            }
                                        );
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                        if (error !== "GRAPH_NOT_FOUND") {
                                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.OPEN_FAILED"));
                                        }
                                    });
                            })
                            .catch(function (error) {
                                _this.loading = false;
                                console.log(error);
                                const apiMessage = (error && error.data && error.data.error && error.data.error.message)
                                    || (error && error.message)
                                    || "";
                                toast.error(
                                    apiMessage
                                        ? $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.CREATE_FAILED") + ": " + apiMessage
                                        : $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_IMPORT.CREATE_FAILED")
                                );
                            });
                    };
                    
                },
            ],
            resolve: {
            },
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
        })
        .result.then(
            function (params) {
            }
        );
    };
};
